import { TActions } from '../../types';
import {
  LOAD_PUBLISH_TERMS_FAIL,
  LOAD_PUBLISH_TERMS_START,
  LOAD_PUBLISH_TERMS_SUCCESS,
  SELECT_PACKAGE,
  SELECT_PLACING_PERIOD,
  SELECT_PLACING_TYPE,
  SELECT_PUBLISH_TERMS_SERVICE,
} from './actions';
import { IPublishTermsState, EPublishTermsStatus } from './types';
import { updatePublishOptions, mergePublishTerms } from './utils';

export const DEFAULT_STATE: IPublishTermsState = {
  status: EPublishTermsStatus.initial,
  services: {},
  serviceIds: [],
  selectedServiceId: null,
  message: null,
  error: null,
};

export function publishTerms(state: IPublishTermsState = DEFAULT_STATE, action: TActions): IPublishTermsState {
  switch (action.type) {
    case LOAD_PUBLISH_TERMS_START:
      return {
        ...state,
        status: EPublishTermsStatus.pending,
        error: null,
      };

    case LOAD_PUBLISH_TERMS_SUCCESS: {
      const publishTerms = mergePublishTerms(state, action.payload.publishTerms);

      return {
        ...state,
        ...publishTerms,
        status: EPublishTermsStatus.success,
      };
    }

    case LOAD_PUBLISH_TERMS_FAIL:
      return {
        ...state,
        status: EPublishTermsStatus.fail,
        error: action.payload || null,
      };

    case SELECT_PUBLISH_TERMS_SERVICE: {
      return {
        ...state,
        selectedServiceId: action.payload,
      };
    }

    case SELECT_PLACING_TYPE: {
      const { services, selectedServiceId } = state;
      const publishOptions = { selectedPlacingType: action.payload };

      const newServices = updatePublishOptions(services, selectedServiceId, publishOptions);

      return {
        ...state,
        services: newServices,
      };
    }

    case SELECT_PACKAGE: {
      const { services, selectedServiceId } = state;
      const publishOptions = { selectedPackageId: action.payload };

      const newServices = updatePublishOptions(services, selectedServiceId, publishOptions);

      return {
        ...state,
        services: newServices,
      };
    }

    case SELECT_PLACING_PERIOD: {
      const { services, selectedServiceId } = state;
      const publishOptions = { selectedPeriodId: action.payload };

      const newServices = updatePublishOptions(services, selectedServiceId, publishOptions);

      return {
        ...state,
        services: newServices,
      };
    }

    default:
      return state;
  }
}
